import { render, staticRenderFns } from "./AuthorTasksList.vue?vue&type=template&id=99b7e23a&"
import script from "./AuthorTasksList.vue?vue&type=script&lang=js&"
export * from "./AuthorTasksList.vue?vue&type=script&lang=js&"
import style0 from "./AuthorTasksList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports